module.exports = "<p>\n  cadastrar-usuario works!\n</p>\n"